<template>
  <div>
    <div class="input-title">DTMF</div>
    <div>
      <v-row>
        <v-col class="p-t-5 p-b-0" cols="12" sm="7" lg="7">
          <v-tooltip left :max-width="350">
            <template v-slot:activator="{ on }">
              <div class="p-l-dfmf" v-on="on">
                DTMF max length
              </div>
            </template>
            <span>
              Max number of digit to accept. (0 = no max limit)
            </span>
          </v-tooltip>
        </v-col>
        <v-col class="d-flex p-t-5 p-b-0" cols="12" sm="5" lg="5">
          <div>
            <v-text-field
              class="margin0 padding0 width70px"
              v-model="dtmf_setting.terminator_length"
              type="number"
              min="4"
              step="1"
              hide-details
              dense
              reverse
            ></v-text-field>
          </div>
          <div class="ml-2">digits</div>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="p-t-5 p-b-0" cols="12" sm="7" lg="7">
          <v-tooltip left :max-width="350">
            <template v-slot:activator="{ on }">
              <div class="p-l-dfmf" v-on="on">
                DTMF timeout
              </div>
            </template>
            <span>
              Duration when no DTMF is detected and a noinput event is raised.
              (0 = no timeout)
            </span>
          </v-tooltip>
        </v-col>
        <v-col class="d-flex p-t-5 p-b-0" cols="12" sm="5" lg="5">
          <div>
            <v-text-field
              class="margin0 padding0 width70px text-center"
              v-model="dtmf_setting.terminator_timeout"
              type="number"
              min="0"
              step="0.01"
              hide-details
              dense
              reverse
            ></v-text-field>
          </div>
          <div class="ml-2">seconds</div>
        </v-col>
      </v-row>

      <v-row>
        <v-col class="p-t-5 p-b-0" cols="12" sm="7" lg="7">
          <v-tooltip left :max-width="350">
            <template v-slot:activator="{ on }">
              <div class="p-l-dfmf" v-on="on">
                DTMF terminator key
              </div>
            </template>
            <span>
              The DTMF key that determines this input is finished.
            </span>
          </v-tooltip>
        </v-col>
        <v-col class="d-flex p-t-5 p-b-0" cols="12" sm="5" lg="5">
          <div class="d-flex">
            <v-select
              class="margin0 padding0 width70px"
              v-model="dtmf_setting.terminator_char"
              :items="categories"
              item-text="text"
              item-value="value"
              placeholder=""
              dense
              hide-details
            >
            </v-select>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col class="d-flex p-t-5 p-b-0" cols="12" sm="12" lg="12">
          <v-checkbox
            v-model="dtmf_setting.dtmf_barge_in"
            label=""
            hide-details
          ></v-checkbox>
          <v-tooltip left :max-width="350">
            <template v-slot:activator="{ on, attrs }">
              <div
                v-bind="attrs"
                v-on="on"
                @click="
                  dtmf_setting.dtmf_barge_in = !dtmf_setting.dtmf_barge_in
                "
              >
                DTMF barge in
              </div>
            </template>
            <span>
              Allow DTMF key press to interrupt before the prompt has finished
              playing.
            </span>
          </v-tooltip>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    dtmf_setting: Object
  },
  watch: {
    dtmf_setting: {
      deep: true,
      immediate: true,
      handler() {
        this.dtmf_setting = this.dtmf_setting
      }
    }
  },
  data() {
    return {
      categories: [
        {
          text: '#',
          value: '#',
          class: 'header-alignment'
        },
        {
          text: '*',
          value: '*'
        },
        {
          text: '0',
          value: '0'
        },
        {
          text: '',
          value: ''
        }
      ]
    }
  }
}
</script>
<style scoped lang="scss">
.width70px {
  // text-align: right !important;
  width: 70px;
}
.p-l-dfmf {
  margin-left: 32px;
}
::v-deep .v-select__selection {
  //ใช้สำหรับตั้งให้ #,* อยู่ตรงกลาง
  padding-left: 25px;
  text-align: center !important;
}
</style>
